const content = {
  component: "PageTypeA",
  cssClass: "page-welcome",
  meta: {
    title: `مرحبًا بك في العدد الجديد من مجلة" غدك...اليوم"`,
    description:
      "From cloud to blockchain, here’s how technology is enabling businesses to reach their full potential.",
    og: {
      type: "website",
      title: "Read stories of tech innovation—see more",
      description: `Whether it's saving the lives of bees or scaling ethical chocolate start-ups, the possibilities of technology are endless. Click here to discover some of the most inspiring stories of digital transformation from across the world of business.  `,
      image: require("../../assets/images/social/welcome-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title:
        "Discover how technology is driving transformation across business",
      description: `From scaling Brazilian wine start-ups to transforming the olive oil supply chain, here are the stories of how pioneering technology is enabling businesses to thrive.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/welcome-300x300.jpg")
    }
  },
  title: `<span>مرحبًا بك في العدد الجديد من مجلة" غدك...اليوم"!</span>`,
  heroImage: {
    preload: require("../../assets/images/bgs/welcome-pre.jpg"),
    loaded: require("../../assets/images/bgs/welcome.jpg"),
    mobile: require("../../assets/images/bgs/welcome-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [true, "top center"]
    },
    mobile: {
      customPosition: [true, "center -20px"]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
          لماذا مجلة "غدك...اليوم"؟ مع كل يوم يمضي، نرى عملاءنا يحققون أهدافهم التجارية عبر الابتكار المتمثّل في استخدام التكنولوجيا السحابية الآمنة لبلوغ أهدافهم الاستراتيجية بسرعة هائلة.  
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>في هذا العدد ستعرف كيف تساعد مزايا تكنولوجيا "البلوك تشين" شركة <b>Certified Origins</b> على ضمان تحقيق الشفافية التامة في إثبات نشأة وأصالة زيت الزيتون (Tuscan Oil) اللذيذ لأي عميل يرغب في استخدامه مع الطعام أو تناوله كوجبة خفيفة مع الخبز.</p>
          <p>ولعلك ستشعر بالدهشة إزاء تجربة شركة <b>CargoSmart</b> العالمية المتخصصة في تطوير حلول برامج ونُظم الشحن، التي وفّرت في توظيف أكثر من 30 شخصًا واستخدام 200 وثيقة كان يستلزمها تجهيز شحنة واحدة للإبحار من الميناء. إن تبسيط منظومة التوريد يؤدي إلى المزيد من الثقة والكفاءة.</p>
          <p>استمتع بمذاق النجاح الذي حققه الصحفي الاستقصائي الهولندي تيون ’توني‘ فان دي كيوكن وزميلاه الصحفيان، الذين أسسوا شركة <b>Tony’s Chocolonely</b> ونجحوا في توسيع نطاق أعمالها، انطلاقًا من مبدأ أخلاقي لإنتاج "شوكولاتة خالية من استغلال الأطفال" والتأثير على الشركات الأخرى المنتجة للشوكولاتة لكي تحذو حذوها.</p>
          <p>في هذا العدد ستعرف أيضًا المزيد عن الشراكة بين Oracle ومشروع <b>The World Bee Project</b> لجمع البيانات حول النحل الذي يقوم بدور جوهري في تلقيح النباتات والزهور في العالم، مما يتيح للباحثين "معرفة" ما يدور داخل خلايا النحل وأوقات احتشادها.</p>
          <p>قصتنا الأخيرة في هذا العدد تحكي عن شركة <b>National Instruments</b> التي يوجد مقرها في أوستن، بولاية تكساس الأمريكية، وتصنع معداتٍ متخصصة متعددة الوحدات وبرامج لتصميم النُظم لاستخدام المهندسين. وتركز الشركة على أسواق تشهد نموًا كبيرًا مثل اختبار أشباه الموصلات، والجيل الخامس اللاسلكي، والمركبات المتصلة، وتكنولوجيا إنترنت الأشياء الصناعية.</p>
          <p>كل حكاية في هذا العدد تبيّن كيف ترسم المؤسسات ذات الرؤية المستقبلية ملامح الغد بقرارات مبتكَرة وذكية تتخذها اليوم.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionAuthor",
      content: {
        author: "Amanda Jobbins",
        position: "VP Demand Generation & Marketing EMEA/APAC",
        image: require("../../assets/images/people/amanda-jobbins.png"),
        type: "author"
      }
    }
  ]
};

export default content;
